import { Box, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { convertDateFormat } from '../utils/convertDateFormat'

interface UserAccidentInfoProps {
  lossDate: string
  registrationNumber: string
}
const UserAccidentInfo = ({
  lossDate,
  registrationNumber,
}: UserAccidentInfoProps): JSX.Element => {
  const { t } = useTranslation('repairshop')

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        width: '100%',
      }}
    >
      <Stack
        sx={{
          py: 2,
          px: 3,
          margin: 'auto',
          maxWidth: 'lg',
        }}
        gap={2}
      >
        <Typography variant="h1">{t('selection-page.title')}</Typography>
        <Typography variant="body1">
          {t('selection-page.accident-info', {
            lossDate: convertDateFormat(lossDate),
            registrationNumber,
          })}
        </Typography>
      </Stack>
    </Box>
  )
}

export default UserAccidentInfo
